import { Navigate, Route, Routes } from "react-router-dom";
import React from "react";
import { useFeatureFlags } from "@/configs/featureFlag";
import { AllMattersList } from "@/features/allMatters/routes/AllMattersList";
import { AllMattersDetail } from "@/features/allMatters/routes/AllMattersDetail";
import { AllMattersPDFUpload } from "@/features/allMatters/routes/AllMattersPDFUpload";
import { AllMattersSearch } from "@/features/allMatters/routes/AllMattersSearch";

export const AllMattersRoutes: React.FC = () => {
  const { allMattersAnalysis, allmattersV2 } = useFeatureFlags();

  return (
    <Routes>
      <Route path="" element={<Navigate to="list" />} />
      {allMattersAnalysis ? (
        <Route path="list" element={<AllMattersList />} />
      ) : null}
      <Route path="detail/:id" element={<AllMattersDetail />} />
      {allMattersAnalysis ? (
        <Route path="upload" element={<AllMattersPDFUpload />} />
      ) : null}
      {allMattersAnalysis && allmattersV2 ? (
        <Route path="search" element={<AllMattersSearch />} />
      ) : null}
      <Route path="*" element={<Navigate to="list" />} />
    </Routes>
  );
};
